"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edge = void 0;
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const util_1 = require("../util");
class Edge {
    constructor(pool, vert0, vert1) {
        this.pool = pool;
        this.vert0 = vert0;
        this.vert1 = vert1;
        this.amountInPrevious = 0;
        this.amountOutPrevious = 0;
        this.canBeUsed = true;
        this.direction = true;
        this.spentGas = 0;
        this.spentGasNew = 0;
        this.bestEdgeIncome = 0;
    }
    cleanCache() {
        this.amountInPrevious = 0;
        this.amountOutPrevious = 0;
        this.canBeUsed = true;
        this.direction = true;
        this.spentGas = 0;
        this.spentGasNew = 0;
        this.bestEdgeIncome = 0;
    }
    reserve(v) {
        return v === this.vert0 ? this.pool.getReserve0() : this.pool.getReserve1();
    }
    getOutput(v, amountIn) {
        let res;
        let gas;
        if (v === this.vert1) {
            if (this.direction) {
                if (amountIn < this.amountOutPrevious) {
                    const { input, gasSpent } = this.pool.getInput(this.amountOutPrevious - amountIn, true);
                    res = this.amountInPrevious - input;
                    gas = gasSpent;
                }
                else {
                    const { output, gasSpent } = this.pool.getOutput(amountIn - this.amountOutPrevious, false);
                    res = output + this.amountInPrevious;
                    gas = gasSpent;
                }
            }
            else {
                const { output, gasSpent } = this.pool.getOutput(this.amountOutPrevious + amountIn, false);
                res = output - this.amountInPrevious;
                gas = gasSpent;
            }
        }
        else {
            if (this.direction) {
                const { output, gasSpent } = this.pool.getOutput(this.amountInPrevious + amountIn, true);
                res = output - this.amountOutPrevious;
                gas = gasSpent;
            }
            else {
                if (amountIn < this.amountInPrevious) {
                    const { input, gasSpent } = this.pool.getInput(this.amountInPrevious - amountIn, false);
                    res = this.amountOutPrevious - input;
                    gas = gasSpent;
                }
                else {
                    const { output, gasSpent } = this.pool.getOutput(amountIn - this.amountInPrevious, true);
                    res = output + this.amountOutPrevious;
                    gas = gasSpent;
                }
            }
        }
        return { output: res, gasSpent: gas - this.spentGas };
    }
    walk(from) {
        (0, tiny_invariant_1.default)(this.amountInPrevious * this.amountOutPrevious >= 0, 'Walk: Invalid amounts');
        const inPrev = this.direction ? this.amountInPrevious : -this.amountInPrevious;
        const outPrev = this.direction ? this.amountOutPrevious : -this.amountOutPrevious;
        const to = from.getNeibour(this);
        if (to) {
            const inInc = from === this.vert0 ? from.bestIncome : -to.bestIncome;
            const outInc = from === this.vert0 ? to.bestIncome : -from.bestIncome;
            const inNew = inPrev + inInc;
            const outNew = outPrev + outInc;
            (0, tiny_invariant_1.default)(inNew * outNew >= 0, 'Walk: Invalid inNew or outNew');
            if (inNew >= 0) {
                this.direction = true;
                this.amountInPrevious = inNew;
                this.amountOutPrevious = outNew;
            }
            else {
                this.direction = false;
                this.amountInPrevious = -inNew;
                this.amountOutPrevious = -outNew;
            }
        }
        else {
            console.error('Error 221');
        }
        this.spentGas = this.spentGasNew;
        (0, util_1.ASSERT)(() => {
            if (this.direction) {
                const granularity = this.pool.granularity1();
                return (0, util_1.closeValues)(this.amountOutPrevious / granularity, this.pool.getOutput(this.amountInPrevious, this.direction).output / granularity, 1e-9);
            }
            else {
                const granularity = this.pool.granularity0();
                return (0, util_1.closeValues)(this.amountInPrevious / granularity, this.pool.getOutput(this.amountOutPrevious, this.direction).output / granularity, 1e-9, `"${this.pool.address}" ${inPrev} ${to?.bestIncome} ${from.bestIncome}`);
            }
        }, 'Error 225');
    }
}
exports.Edge = Edge;
